import { AbstractDataClass, column } from '@/helpers/AbstractDataClass';
import { AdminSite } from '@/store/adminsite/types';

export interface Region {
  _id?: string;
  name?: string;
  adminsites?: Array<AdminSite>;
}

export interface RegionState {
  region?: Region;
  dataRegion?: DataRegion[];
}

export class DataRegion extends AbstractDataClass<DataRegion>
  implements Region {
  public _id: string;

  @column({
    label: 'Nom de la région',
    placeholder: 'Nom de la région',
    isArray: false,
    isSearchable: true,
  })
  public name?: string;

  @column({
    label: 'Sites',
    isArray: true,
    nameDropDown: 'Liste des sites',
    name: 'name',
  })
  public adminsites: Array<AdminSite> = [];

  static fromJSON(object: Region): DataRegion {
    let dataRegion = new DataRegion();
    dataRegion = Object.assign(dataRegion, object);
    return dataRegion;
  }
}
